import React, { useState } from 'react';
import styled from 'styled-components';
import TermsModal from './TermsModal';
import burgerIcon from '../assets/img/burger-icon.svg';
import wholeBigMac from '../assets/img/whole-big-mac.png';

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #DB0007;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
`;

const IconWrap = styled.div`
  margin-bottom: 28px;
`;

const Heading = styled.h2`
  font-family: 'Speedee Bold';
  font-size: 56px;
  line-height: 1;
  color: #FFFFFF;
  text-align: center;
  margin: 0 0 32px;
  letter-spacing: -1px;
  max-width: 800px;
`;

const WhiteCard = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 600px;
  width: 100%;
  box-sizing: border-box;
`;

const BurgerIconImg = styled.img`
  width: 61px;
  height: 101px;
  flex-shrink: 0;
`;

const CardContent = styled.div`
  flex: 1;
`;

const CardHeading = styled.h3`
  font-family: 'Speedee Bold';
  font-size: 32px;
  line-height: 1.2;
  color: #2D2D2D;
  margin: 0 0 8px;
`;

const CardText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 12px;
  line-height: 1.4;
  color: #2D2D2D;
  margin: 0;

  a {
    color: #2D2D2D;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const BigMacImage = styled.img`
  width: 600px;
  max-width: 100%;
  margin-top: -144px;
  display: block;
  pointer-events: none;
`;

const DeviceNotice = ({type, offer}) => {
  const [showTerms, setShowTerms] = useState(false);

  return (
    <Wrapper>
      <>
        {
          type === 'rotate-device' ? (
            <>
              <IconWrap>
                <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M34.1532 10.6287L28.8697 6.71126C28.0059 6.0684 28.026 5.26483 28.8697 4.64206L34.1532 0.704562C35.3385 -0.179367 36.584 0.20233 36.584 1.7492V4.36081H37.2269C43.1331 4.36081 47.1912 8.39876 47.1912 14.3452V17.5193C47.1912 18.3229 46.5282 19.0059 45.7246 19.0059C44.9211 19.0059 44.2581 18.3229 44.2581 17.5193V14.3452C44.2581 10.1063 41.5059 7.09295 37.247 7.09295H36.584V9.60412C36.584 11.1108 35.3385 11.4925 34.1532 10.6287ZM6.5865 48.764H22.3767C25.7919 48.764 28.0619 46.5341 28.0619 43.2193V10.3533C28.0619 7.03852 25.7919 4.80861 22.3767 4.80861H6.5865C3.13114 4.80861 0.800781 7.03852 0.800781 10.3533V43.2193C0.800781 46.5341 3.13114 48.764 6.5865 48.764ZM7.24944 44.726C5.66239 44.726 4.73828 43.8421 4.73828 42.3153V11.2573C4.73828 9.73049 5.66239 8.86665 7.24944 8.86665H21.6334C23.2204 8.86665 24.1445 9.73049 24.1445 11.2573V42.3153C24.1445 43.8421 23.2204 44.726 21.6334 44.726H17.6959V44.0229C17.6959 43.139 17.1133 42.5564 16.2494 42.5564H12.6535C11.7695 42.5564 11.207 43.139 11.207 44.0229V44.726H7.24944ZM31.8744 48.7548H39.1378C42.4526 48.7548 44.6825 46.4847 44.6825 43.0696V27.2794C44.6825 23.824 42.4526 21.4937 39.1378 21.4937H31.8744V25.4312H38.2338C39.7606 25.4312 40.6244 26.3553 40.6244 27.9423V42.3263C40.6244 43.9133 39.7606 44.8374 38.2338 44.8374H31.8744V48.7548Z" fill="#FFFFFF"/>
                </svg>
              </IconWrap>

              <Heading>Please rotate your device</Heading>
            </>
          ) : (
            <>
              <IconWrap>
                <svg width="77" height="43" viewBox="0 0 77 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.18917 41.9866L45.8036 41.9866C45.2511 40.9821 44.9247 39.7768 44.9247 38.4961C44.9247 37.4916 45.1507 36.6127 45.6529 35.5831L13.4347 35.5831L13.4347 7.25725C13.4347 5.67522 14.2132 4.92187 15.7701 4.92187L58.1585 4.92187C59.7405 4.92187 60.519 5.67522 60.519 7.25725L60.519 12.3298C61.2974 12.0033 62.1261 11.8527 62.9799 11.8527C63.8588 11.8527 64.6875 12.0033 65.4408 12.3549V5.97656C65.4408 2.05915 63.3064 0 59.4141 0L14.5145 0C10.798 0 8.51283 2.05915 8.51283 5.97656L8.51283 35.5831H3.18917C1.43136 35.5831 0 37.0396 0 38.7974C0 40.5552 1.43136 41.9866 3.18917 41.9866ZM52.1066 42.0117L73.8532 42.0117C75.9877 42.0117 77.394 40.4297 77.394 38.4961C77.394 37.8934 77.2433 37.3158 76.9169 36.7634L66.0184 17.3019C65.3404 16.0965 64.1853 15.519 63.005 15.519C61.7997 15.519 60.5943 16.0965 59.9414 17.3019L49.0681 36.7634C48.7416 37.3158 48.591 37.8934 48.591 38.4961C48.591 40.4297 49.9721 42.0117 52.1066 42.0117ZM62.9799 32.0675C62.0257 32.0675 61.3477 31.4146 61.2974 30.4604L61.0965 23.4794C61.0714 22.3744 61.8499 21.596 62.9799 21.596C64.135 21.596 64.9135 22.3493 64.8884 23.4794L64.6875 30.4604C64.6373 31.4146 63.9593 32.0675 62.9799 32.0675ZM62.9799 38.1948C61.7243 38.1948 60.7199 37.2154 60.7199 35.9598C60.7199 34.7294 61.7494 33.75 62.9799 33.75C64.2606 33.75 65.2651 34.7545 65.2651 35.9598C65.24 37.2154 64.2606 38.1948 62.9799 38.1948Z" fill="white"/>
                </svg>
              </IconWrap>

              <Heading>This campaign is only available on mobile</Heading>
            </>
          )
        }

        <WhiteCard>
          <BurgerIconImg src={burgerIcon} alt="" />
          <CardContent>
            <CardHeading>Join MyMacca's® to get access to future drops and rewards.</CardHeading>
            <CardText>
              *Only valid once added to MyMacca's® account. Limited quantities. Redeem within 48 hours of game end. <a onClick={() => setShowTerms(true)}>Terms & Conditions apply.</a>
            </CardText>
          </CardContent>
        </WhiteCard>

        <BigMacImage src={wholeBigMac} alt="Big Mac" />

        {showTerms && <TermsModal offer={offer} onClose={() => setShowTerms(false)} />}
      </>
    </Wrapper>
  );
};

export default DeviceNotice;
